import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { spinnerOff, spinnerOn } from '../../components/Spinner';
import { deleteIPSDataTracker, get, getIpsStations, post, } from '../../api';

import IpsDTProjectGrid from '../../components/ProjectsGrid/IpsDTProjectGrid';

import IpsDTProjectList from 'components/ProjectsList/IpsDTProjectList';
import IPSDTViewType from 'components/ViewType/IPSDTViewType';
import ConfirmDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/ConfirmDialogBox';
import MatchProjectsDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/MatchProjectsDialog';
import DeleteConfirmationDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/DeleteConfirmationDialog';
import EditProjectDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/EditProjectDialog';
import DuplicateBPIDDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/DuplicateBPIDDialog';


export default withRouter(function DataTrackerMatchedDuplicate(props) {
  const { context, history, cardview, onViewTypeChange, projectList,ipsStations } = props;
  const [projects, setProjects] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [duplicateProjects, setDuplicateProjects] = useState([]);
  const [openModal, setOpenModal] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [openEditModal, setOpenEditModal] = useState(false)
  const [selectedProject, setSelectedProject] = useState(null)
  const [stations, setStation] = useState(ipsStations)
  const [openDuplicateModal, setOpenDuplicateModal] = useState(false)
  const [confirmationDetails, setConfirmationDetails] = useState({})
  const [isBPIDClear, setIsBPIDClear] = useState(false)

  const handleCancel = () => {
    setOpenModal(false)
  }

  const handleDeleteCancel = () => {
    setOpenDeleteModal(false)
    setOpenModal(true)
  }

  const handleDelete = () => {
    setConfirmationDetails({
      title: "Are you sure you want to delete the following project?",
      handleCancel: handleDeleteCancel,
      handleClickOK: deleteDataTracker
    })

    if (selectedProject) {
      setOpenDeleteModal(true)
      setOpenModal(false)
    }

  }
  const onSelectProject = (project) => {
    setSelectedProject(project)
  }

  async function deleteDataTracker(project) {
    const response = await deleteIPSDataTracker(project)
    if (response.status = 'SUCCESS') {
      goToProject(selectedProject)
      getProjects()
      setOpenEditModal(false)
      setOpenDeleteModal(false)
    }

  }

  const handleEditClick = () => {
    if (selectedProject) {
      setOpenEditModal(true)
      setOpenModal(false)
    }
  }

  const handleEditCancel = () => {
    setOpenEditModal(false)
    setOpenModal(true)
    setIsBPIDClear(false)
  }

  const handleEditSave = async (data) => {
    setIsBPIDClear(false)
    const payload = {
      newBPID: data.bpid,
      newStationName: data.stationName,
      newWO: data.workOrder,
      bpid: selectedProject.bpid,
      workOrder: selectedProject.workOrder,
      stationName: selectedProject.stationName
    }

    const result = await post(`ipsprojects/clone`, '', payload);
    if (result.status === "SUCCESS") {
      goToProject(selectedProject)
      getProjects()
      setOpenEditModal(false)
      setOpenDeleteModal(false)
    }
    else if (result.status === "WARNING" && result.statusMsg === "DUPLICATE_FOUND") {
      setOpenDuplicateModal(true)
      setOpenEditModal(false)
      setOpenModal(false)
    }

  }

  const handleDuplicateCancel = () => {
    setOpenDuplicateModal(false)
  }

  const handleClickOK = () => {
    setOpenEditModal(true)
    setIsBPIDClear(true)
    setOpenDuplicateModal(false)
  }

  const handleAccept = () => {
    setConfirmationDetails({
      title: "Are you sure you want to accept the following project?",
      handleCancel: handleDeleteCancel,
      handleClickOK: acceptDataTracker
    })
    if (selectedProject) {
      setOpenDeleteModal(true)
      setOpenModal(false)
      setOpenDuplicateModal(false)
      setOpenEditModal(false)
    }

  }

  const acceptDataTracker = async (project) => {

    const result = await post(`ipsprojects/accept`, '', project);
    if (result.status === 'SUCCESS') {
      goToProject(selectedProject)
      getProjects()
      setOpenEditModal(false)
      setOpenDeleteModal(false)
    }

  }

  async function getProjects() {

    spinnerOn();
    setIsLoading(true);
    const result = await post(`ipsprojects/duplicates`, '', {});
    setProjects(result.data);
    spinnerOff();
    setIsLoading(false);

  }

  const redirectToProject = () => {
    
    

    let encodedStationName = encodeURIComponent(selectedProject.stationName)
    history.push(
      `/datatracker_progress/${encodedStationName}/${selectedProject.bpid}/${selectedProject.workOrder}/details`
    );
  }

  useEffect(() => {

    getProjects();
  }, []);

  
  async function goToProject(project) {

    const response = await get(`ipsprojects/duplicates/${project.tclProjectId}`)
    
    setSelectedProject(null)
    if(response.data.length>0 ){
      const projects = response.data.filter(project=> (project.duplicate || project.tclSyncFlag==='N' || project.manual))
      setDuplicateProjects(projects? projects: []);
      
      if(projects.length>0){
        setOpenModal(true)
      } else {
        setOpenModal(false)
      }
  
    
  }
  }
  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flewGrow: 1,
          justifyContent: 'center',
          paddingRight: '16px',
          paddingBottom: '16px',
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <IPSDTViewType
          onViewTypeChange={onViewTypeChange}
          tabView={'DT_D'}
          dtstatus={'DT_D'}
        />
      </div>
      {cardview === 'cardview' ? (
        <IpsDTProjectGrid
          projects={projectList(projects)}
          history={history}
          context={context}
          onButtonClick={goToProject}
          isLoading={isLoading}
          {...props}
        />
      ) : (
        <IpsDTProjectList
          projects={projectList(projects)}
          onButtonClick={goToProject}
          {...props}
        />
      )}
      
      <MatchProjectsDialog
        show={openModal}
        duplicateProjects={duplicateProjects}
        handleCancel={handleCancel}
        handleDelete={handleDelete}
        onSelectProject={onSelectProject}
        onEditClick={handleEditClick}
        onAccept={handleAccept}
        project={selectedProject}
      />
      {selectedProject &&
        <>
          <DeleteConfirmationDialog
            title={confirmationDetails.title}
            show={openDeleteModal}
            project={selectedProject}
            handleCancel={confirmationDetails.handleCancel}
            handleClickOK={confirmationDetails.handleClickOK}
          />

          <EditProjectDialog
            show={openEditModal}
            project={selectedProject}
            stations={ipsStations}
            isBPIDClear={isBPIDClear}
            handleCancel={handleEditCancel}
            onSubmit={handleEditSave} />
        </>
      }
      <DuplicateBPIDDialog
        show={openDuplicateModal}
        handleCancel={handleDuplicateCancel}
        onClickOk={handleClickOK}
        goToProject={redirectToProject}
      />
    </Fragment>
  );
});